import { render, staticRenderFns } from "./ThinkHome.vue?vue&type=template&id=29ed1bd0&scoped=true"
import script from "./ThinkHome.vue?vue&type=script&lang=js"
export * from "./ThinkHome.vue?vue&type=script&lang=js"
import style0 from "./ThinkHome.vue?vue&type=style&index=0&id=29ed1bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed1bd0",
  null
  
)

export default component.exports